export default __webpack_public_path__ + "static/media/T15.41700514.JPG";